import Instance from "../../../Axios";

const GetAllPrioridades = () => async (dispatch) => {
  await Instance()
    .get(`/intervencoes/intervencoes/prioridades/all`)
    .then(({ data }) => {
      dispatch({ type: "GET_ALL_PRIORIDADES", payload: data.yData });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetAllPrioridades;